import booleanHelper from "./booleanHelper";

export class listtableHelper {
  static convertToWords(text) {
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  static formatDate(date) {
    const d = new Date(date);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join("-");
  }

  static valueWithTwoDecimalPlaces(value) {
    if (!value) return "0.00";
    return value.toFixed(2);
  }

  static boolValueAsText(boolValue) {
    if (typeof boolValue === "string") boolValue = booleanHelper.toBoolean(boolValue);
    return boolValue ? "Yes" : "No";
  }
}

export default listtableHelper;
